<div class="share-sales-wrapper">
    <ev-grid-table [gridModel]="displayTemplate" class="scrollable-table">
        <ev-th>
            <ev-td class="spacing-left" area="spacingLeft"></ev-td>

            @for (column of headers; track $index) { 
            @if (column?.isSortable) {
            <ev-td
                [area]="column.prop"
                (click)="updateSort(column.prop)"
                [isSelectable]="true"
                [textAlignment]="column.textAlignment ?? 'left'"
                [selected]="sortConfig().sortOption.prop == column.prop"
            >
                {{ column.name.toUpperCase() }}
            </ev-td>
            } @else {
            <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                {{ column.name.toUpperCase() }}
            </ev-td>
            } }
        </ev-th>
        @if (tableData()) { 
        @for (rowData of tableData(); track $index) {

        <ev-tr class="ev-row" [hasRowContent]="true" (isExpanded)="isRowExpanded($event, rowData)">
            <ev-td area="estateType" column [title]="rowData.estateType">
                <div class="estate-type" [class]="rowData.estateType"></div>
            </ev-td>
            <ev-td area="soldDate" header="" column title="" [fontBold]="sortConfig().sortOption.prop == 'soldDate'">
                <div class="column-data">{{ rowData.soldDate | date : "shortDate" }}</div>
            </ev-td>
            <ev-td
                area="residentialMeasuredArea"
                header=""
                column
                textAlignment="right"
                title=""
                [fontBold]="sortConfig().sortOption.prop == 'residentialMeasuredArea'"
            >
                <div class="column-data">{{ rowData.residentialMeasuredArea | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td area="floor" header="" column title="" textAlignment="right" [fontBold]="sortConfig().sortOption.prop == 'floor'">
                <div class="column-data">{{ rowData.floor | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td area="salesPrice" header="Pris" column title="Pris" textAlignment="right" [fontBold]="sortConfig().sortOption.prop == 'salesPrice'">
                <div class="column-data">{{ rowData.salesPrice | thousandize | defaultconvert : "-" }}</div>
            </ev-td>
            <ev-td area="finnAd" header="" column title="" textAlignment="right">
                @if (rowData.sourceUrl) {
                <a [href]="rowData.sourceUrl" target="_blank" rel="noopener noreferrer" class="link-with-icon">
                    <span class="main-link-item finn"></span>Se Finn-annonse
                </a>
                } @else if (rowData.sourceUrl_Hjem) {
                <a [href]="rowData.sourceUrl_Hjem" class="link-with-icon" target="_blank" rel="noopener noreferrer">
                    <span class="main-link-item hjem"></span> Se Hjem-annonse
                </a>
                }
            </ev-td>
            <ev-td area="prospect" header="" column title="" textAlignment="right">
                @if (rowData.hasAdText) {
                <a [href]="rowData.prospectUrl" target="_blank" rel="noopener noreferrer" class="link-with-icon">
                    <span class="main-link-item prospect"></span>Se prospekt
                </a>
                }
            </ev-td>
            <div row-content>
                <share-sales-detail [data]="rowData" [imagePackages]="imagePackageDictionary()[rowData.saleId] || []"></share-sales-detail>
            </div>
        </ev-tr>
        } }
    </ev-grid-table>
</div>
@if (originalData().length > rowsToShow) {
<div class="show-more-button">
    <button (click)="onShowMore()">Vis flere</button>
</div>
}
